import { adminApi } from '../providers/dataProvider';
import { useAdminQuery } from './useAdminQuery';

export function useSharedAllowance(userId: string, enabled = true) {
  return useAdminQuery(['admin-shared-allowance', userId], () => adminApi.getSharedAllowance(userId), enabled);
}
